/* tslint:disable */
/* eslint-disable */
/**
 * SLM API used by SLM frontend
 * This is the specification of the backend APIs. The main purpose of this specification is to unify the API between SLM-backend and SLM-frontend. For localizations the Accept-Language header is used.
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: dl.mhs.bd3.se@ingka.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const UpdateAction = {
    UNDEFINED: '0',
    CREATE: '1',
    UPDATE: '2',
    DELETE: '3',
    DELETE_INSERT_UPDATED: '5',
} as const;
export type UpdateAction = typeof UpdateAction[keyof typeof UpdateAction];


export function instanceOfUpdateAction(value: any): boolean {
    for (const key in UpdateAction) {
        if (Object.prototype.hasOwnProperty.call(UpdateAction, key)) {
            if (UpdateAction[key as keyof typeof UpdateAction] === value) {
                return true;
            }
        }
    }
    return false;
}

export function UpdateActionFromJSON(json: any): UpdateAction {
    return UpdateActionFromJSONTyped(json, false);
}

export function UpdateActionFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateAction {
    return json as UpdateAction;
}

export function UpdateActionToJSON(value?: UpdateAction | null): any {
    return value as any;
}

export function UpdateActionToJSONTyped(value: any, ignoreDiscriminator: boolean): UpdateAction {
    return value as UpdateAction;
}

